import { UseQueryResult, useQuery } from 'react-query'
import { fetchCategories } from './services'
import { CategoriesType } from './types'

export function useCategoriesQuery(): UseQueryResult<CategoriesType> {
   return useQuery('categories', fetchCategories)
}
